const ZIPCODE_REGEX = /^\d{5}$/;
export default (({
  message = 'Please enter a valid zip code'
} = {}) => value => {
  if (!ZIPCODE_REGEX.test(value)) {
    return message;
  }
  return null;
});